import { render, staticRenderFns } from "./LookupFields.vue?vue&type=template&id=96cf45ce&"
import script from "./LookupFields.vue?vue&type=script&lang=js&"
export * from "./LookupFields.vue?vue&type=script&lang=js&"
import style0 from "./LookupFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports